
import WDButton from './wd-button'

export default class WDCheckButton extends WDButton {

  #checked = false;
  #value = null;

  constructor(cfg)
  {
    super(cfg).classList.add('wd-check-button');
    
    this.checked = false;   
    this.icon = 'fa-solid fa-check';
    this.on('click',() => this.toggle() );
  };
  
  toggle()
  {
    if (this.checked == true) this.checked = false;
    else this.checked = true;
  };

  get value() { return this.#value; };
  set value(val) {
    this.#value = val;
    this.trigger('value:set');
  };
  
  get checked() { return this.#checked; };
  set checked(val)
  {
    this.#checked = val;

    if (val === true) this.classList.add('is-checked');
    else this.classList.remove('is-checked');
  };
  
};

customElements.define('wd-check-button',WDCheckButton);
